import fetch from "isomorphic-fetch"
import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client"

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: "https://us1.prisma.sh/maximiliano-techera-e8c0e0/la-funcion-debe-continuar/production",
    fetch,
  }),
})

export default client
